import type { Subscriber } from '@setplex/tria-api'
import type { Store } from 'effector'

import { api } from '@setplex/tria-api'
import { attach, createEvent, createStore, sample } from 'effector'
import { model as sessionModel } from '~/entities/session'
import { updateProfileSwitchLocked } from './lib'

export const init = createEvent()
export const reset = createEvent<void>()

// get subscriber effect
export const getSubscriberFx = attach({ effect: api.subscriber.getFx })

sample({
  clock: sessionModel.effectiveUnauthorized,
  target: reset,
})

// subscriber store
export const $subscriber: Store<Subscriber | null> =
  createStore<Subscriber | null>(null)
    .on(getSubscriberFx.doneData, (_, subscriber) => subscriber)
    .on(
      api.subscriber.updateProfileSwitchLockedFx,
      (state, profileSwitchLocked) =>
        updateProfileSwitchLocked(state, profileSwitchLocked)
    )
    .on(api.subscriber.updateProfileSwitchLockedFx.fail, (state, { params }) =>
      updateProfileSwitchLocked(state, !params)
    )
    .reset(reset)
